export default {
  users: [],
  selectedRole: 'members',
  userType: 'existing',
  isAddFormVisible: false,
  isResponseMessageVisible: false,
  latestAssociationDisplayName: '',
  latestAssociationStatusCode: '',
  latestAssociationMessage: '',
  errorMessage: '',
};




// WEBPACK FOOTER //
// ./src/store/modules/linkUser/linkUser.state.js